import React, { useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import SampleDetailsTab from './SampleDetailsTab'
import ConcreteDetailsTab from './ConcreteDetailsTab'
import FieldArtifactsTab from './FieldArtifactsTab'
import LabResultsTab from './LabResultsTab'

const SampleTabs = ({sample, callback}) => {
    const [activeTab, setActiveTab] = useState("sampledetails");
    const tabs = [
        new Tab({ label: "Sample Details", value: "sampledetails" }),
        // new Tab({ label: "Field Artifacts", value: "fieldartifacts" }),
        new Tab({ label: "Lab Results", value: "labresults" }),
       // new Tab({ label: "Lab Attachments", value: "labattachments" }),
    ]
    
    sample.Category_FieldMaterial === "Concrete" && tabs.splice(1, 0, new Tab({ label: "Concrete Details", value: "concretedetails" }));

    return (
        <div>
                <TabbedPage
                    tabs={tabs}
                    activeTab={activeTab}
                    tabSetterFunc={setActiveTab}
                >
                    {(() => {
                        switch (activeTab) {
                            case "sampledetails": return <SampleDetailsTab defaultValues={sample} />
                            case "concretedetails": return  <ConcreteDetailsTab defaultValues={sample} /> 
                            case "fieldartifacts": return <FieldArtifactsTab />
                            case "labresults": return <LabResultsTab  sample={sample} callback={callback}/>
                           // case "labattachments": return <LabAttachmentsTab />
                            default: return <SampleDetailsTab />
                        }
                    })()}
                </TabbedPage>
        </div>
    )
}

export default SampleTabs;